import { getEventListByType } from '@/common/util/event.util'
import { ON_CLICK } from '@/common/event.const'
import { EventBus } from '@/components//eventbus/EventBus'
import { parseUrl } from 'query-string'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import { useRouterComposable } from '@/common/use/useRouterComposable'

export const cellHelper = () => {
  const { pushRouter } = useRouterComposable()

  /**
   * Send event on click
   * @param onClickEvent
   */
  const sendEventOnClick = (onClickEvent) => {
    EventBus.$emit(ON_CLICK, onClickEvent)
  }

  /**
   * 셀 클릭 상세보기 진입
   * @param cell
   * @returns {undefined}
   */
  const onSelectCell = (cell) => {
    const cellEventList = cell?.event_list ?? []

    // 이미지 편성일 경우 상세보기 진입 x
    if (cellEventList?.length === 0) {
      return undefined
    }

    const { onNavigationEvent, onClickEvent } =
      getEventListByType(cellEventList)

    if (onClickEvent) {
      sendEventOnClick(onClickEvent)
    }

    const navigationUrl = (onNavigationEvent?.url ?? '').replaceAll('.html', '')
    const { url, query } = parseUrl(navigationUrl)
    const section = url.split('/').pop()

    pushRouter({
      name: PATH_NAME_PLAYER,
      params: { section },
      query,
    })
  }

  return {
    sendEventOnClick,
    onSelectCell,
  }
}
